const userStatusErrors = Object.freeze({
  USER_BANNED: 'USER_BANNED',
  USER_SUSPENDED: 'USER_SUSPENDED',
});

export const { USER_BANNED, USER_SUSPENDED } = userStatusErrors;
